export default __webpack_public_path__ + "static/media/noorafkan.e2341d86.png";